import React, { useState } from 'react';
import { Calendar } from 'react-date-plus-time-range';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import strings from 'strings';
import TextBox from 'UI/components/atoms/TextBox';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import { DateFormats } from 'UI/constants/defaults';
import { dateFormatter } from 'UI/utils';

import { styles, useStyles } from './styles';

/** @typedef {import('@material-ui/pickers').DatePickerProps} DatePickerProps */
/** @typedef {import('@material-ui/pickers'').DatePickerProps} DatePickerProps */
/**
 * @param {DatePickerProps} props
 */
const DatePicker = ({ defaultDate, onApplyClick }) => {
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(false);
  const [date, setDate] = useState(moment(defaultDate).format(DateFormats.SimpleDate));

  const handleOpen = () => setIsOpen(true);

  const handleChange = newDate => setDate(dateFormatter(newDate, formats => formats.SimpleDate));

  const handleCancel = () => {
    setIsOpen(false);
    setDate(dateFormatter(defaultDate, formats => formats.SimpleDate));
  };

  const handleApply = () => {
    setIsOpen(false);
    onApplyClick && onApplyClick(dateFormatter(date, formats => formats.SimpleDateHyphen));
  };

  const buttonDefinitions = [
    {
      props: {
        text: strings.shared.ui.cancel,
        variant: 'outlined',
        onClick: handleCancel,
        size: 'small'
      }
    },
    {
      props: {
        text: strings.shared.ui.applyFilters,
        variant: 'contained',
        onClick: handleApply,
        size: 'small'
      }
    }
  ];

  return (
    <>
      <TextBox
        name="datePicker"
        label="Date Picker"
        value={date}
        onFocus={handleOpen}
        inputProps={{
          style: styles.datePickerField
        }}
      />
      {isOpen && (
        <div className={classes.datePickerContainer}>
          <div className={classes.calendarContainer}>
            <Calendar
              date={date}
              showSelectionPreview
              direction="horizontal"
              onChange={handleChange}
            />
            <Grid className={classes.calendarToolbar}>
              <FPButtonBuilder
                GridContainerProps={{ spacing: 2, justifyContent: 'center' }}
                buttonDefinitions={buttonDefinitions}
              />
            </Grid>
          </div>
        </div>
      )}
    </>
  );
};

export default DatePicker;
